module.exports = __webpack_public_path__ + "assets/img/Logo-KC.097f8656.png";